import { IListItem } from '../List';
import { PASSWORD, CHECKBOX, EMAIL, MOBILE, VALIDATION_CODE, ALPHANUMERIC, PASSWORD_SHOWN, PIN } from './index';

export const regExp = {
	hasUpperLetter: /[A-Z]/,
	hasLowerLetter: /[a-z]/,
	hasNumbers: /\d{1,}/,
	hasSpecialCaracter: /[ `¡!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/¿?~]/,
	hasNumberMobile: /^[5][5]\d{4}\d{4}$/,
	hasNumberCode: /^[1-9]\d{21}$/,
	hasAtLeast8Chr: /.{8,}/,
	hasAtLeast1NotEmptyChr: /\S{1,}/,
	emptyOrWhiteSpace: /^$|\s+/,
	validEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	isChecked: /^true/,
	isValidPassword: /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,}$/,
	validtext: /^[A-Za-z0-9\s]+$/,
	hasPin: /^[1-9]\d{5}/
};

const translationIDs = ['password_title',
						'password_tooltip_letter',
						'password_tooltip_number',
						'password_tooltip_length',
						'password_tooltip_completeField',
						'password_tooltip_check',
						'password_tooltip_especial_character',
						'email_tooltip_valid',
            'loginMail_tooltip_error_label',
						'registerMail_tooltip_error',
            'loginPassword_tooltip_error_label',
		'form_tooltip_empty_label_validation',
		'form_tooltip_invalidPan_label_validation',
		'form_tooltip_lengthPan_label_validation',
		'resilence_warning_title_label',
		'resilence_warning_waitMessage_label',
		'resilence_warning_button_retry',
		'resilence_warning_tryMessage_label',
		'error_server_tooltip'] as const;

export type TranslationID = typeof translationIDs[number];

export const getValidations = (type: string, value: string, translations?: Record<TranslationID, string>, error?: boolean): IListItem[] => {

	let text = '';
	const result: IListItem[] = [];
	switch (type) {
		case PASSWORD_SHOWN:
		case PASSWORD:
			// USR-12. Contraseña con letras
			text = 'Mayúsculas y minúsculas.';
			if(translations){
				text = translations['password_tooltip_letter'] ?? text;
			}

			result.push({
				text,
				variant: regExp.hasUpperLetter.test(value) && regExp.hasLowerLetter.test(value) ? 'success' : error ? 'error-password': 'default'
			});
			// USR-13. Contraseña con números
			text = 'Al menos un número.';
			if(translations){
				text = translations['password_tooltip_number'] ?? text;
			}
			result.push({
				text,
				variant: regExp.hasNumbers.test(value) ? 'success' : error ? 'error-password': 'default'
			});
			// USR-14. Contraseña con 8 caracteres
			text = '8 o más caracteres.';
			if(translations){
				text = translations['password_tooltip_length'] ?? text;
			}

			result.push({
				text,
				variant: regExp.hasAtLeast8Chr.test(value) ? 'success' : error ? 'error-password': 'default'
			});
			// USR-15. Contraseña con al menos un caracter
			// Actualizacion esta validacion ya no va, se queda comentada por si cambian de opinion
			// https://dlatvarg.atlassian.net/browse/STV-12021
			/*
			result.push({
				text: 'Al menos un caracter especial',
				variant: regExp.hasSpecialCaracter.test(value) ? 'success' : 'default'
			})
			*/
			text = 'Sin caracteres especiales.';
			if(translations){
				text = translations['password_tooltip_especial_character'] ?? text;
			}
			result.push({
				text,
				variant: regExp.validtext.test(value)  ? 'success' : error ? 'error-password': 'default'
			})
			break;
		case EMAIL:
			// USR-8.2. La primer letra escrita
			if(value.length === 1){
				text = 'Debes completar este campo.';
				if(translations){
					text = translations['password_tooltip_completeField'] ?? text;
				}
				result.push({
					text,
					variant: 'error'
				});
			}else{
				text = 'Ingresa un correo electrónico válido.';
				if(translations){
					text = translations['email_tooltip_valid'] ?? text;
				}
				result.push({
					text,
					variant: regExp.validEmail.test(value) ? 'success' : 'error'
				});
			}
			break;
		case MOBILE:
			result.push({
				text: value.length === 1 ? 'Debes completar este campo.' : 'Ingresa un número celular válido',
				variant: regExp.hasNumberMobile.test(value) ? 'success' : 'error'
			});
			break;
		case VALIDATION_CODE:
			text = 'Debes completar este campo para continuar.';
			if(translations){
				text = translations['form_tooltip_empty_label_validation'] ?? text;
			}
			result.push({
				text,
				variant: regExp.hasNumberCode.test(value) ? 'success' : 'error'
			});
			break;
		case ALPHANUMERIC:
			text = 'Debes completar este campo.';
			let textAlt = 'Ingresa un correo electrónico válido.';
			if(translations){
				text = translations['password_tooltip_completeField'] ?? text;
				textAlt = translations['email_tooltip_valid'] ?? textAlt;
			}
			result.push({
				text: value.length === 1 ?text : regExp.hasUpperLetter.test(value) || regExp.hasLowerLetter.test(value) ? textAlt : 'Ingresa un número celular válido',
				variant: regExp.validEmail.test(value) || regExp.hasNumberMobile.test(value) ? 'success': 'error'
			});
			break;
		case CHECKBOX:
			text = 'Debes Aceptar los términos y condiciones..';
			if(translations){
				text = translations['password_tooltip_check'] ?? text;
			}
			result.push({
				text,
				variant:  'error'
			});
			break;
		case PIN:
			result.push({
				text: value.length === 1 ? 'Debes completar este campo.' : '',
				variant: regExp.hasNumberCode.test(value) ? 'success' : 'error'
			});
			break;
		default:
			// USR-xxx. miunimo 1 caracter
			result.push({
				text: 'Debe contener al menos 1 caracter.',
				variant: regExp.hasAtLeast1NotEmptyChr.test(value) ? 'success' : 'error'
			});
	}
	return result;
};

export const getTitle = (type: string, translations?: Record<TranslationID, string>) => {
	let title = '';
	let variant = 'default';

	switch (type) {
		case PASSWORD_SHOWN:
		case PASSWORD:
			title = 'Tu contraseña debe incluir';
			if(translations){
				title = translations['password_title'] ?? title;
			}
			variant = 'default';
			break;
		case EMAIL:
			variant = 'default';
			break;
		case CHECKBOX:
			variant = 'default';
			break;
		case MOBILE:
			variant = 'default';
			break;
		case VALIDATION_CODE:
			variant = 'default';
			break;
		case ALPHANUMERIC:
			variant = 'default';
			break;
		case PIN:
			variant = 'default';
			break;
		default:
			title = 'Tu texto debe incluir';
			variant = 'default';
	}
	return { title, variant };
};




// WEBPACK FOOTER //
// ./src/packages/components/lib/Input/utils.ts